/* ═══════════════════════════════════════════════════════════════════════════════
   BATI VIZ — Design Tokens
   ═══════════════════════════════════════════════════════════════════════════════ */

export const C = {
  navy: "#0D1B2A",
  navyMid: "#1E3A5F",
  accent: "#F59E0B",
  green: "#16A34A",
  greenBg: "#ECFDF5",
  red: "#DC2626",
  redBg: "#FEF2F2",
  blue: "#3B82F6",
  slate: "#64748B",
  slateLight: "#94A3B8",
  bg: "#F8FAFC",
  surface: "#FFFFFF",
  border: "#E5E9EF",
  text: "#0D1117",
};

export const font = "'Inter', system-ui, sans-serif";
export const mono = "'JetBrains Mono', monospace";

export const MOIS = [
  "", "Jan", "Fév", "Mar", "Avr", "Mai",
  "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc",
];
